module.exports = __webpack_public_path__ + "static/media/training_presence_report.25a1aba6.svg";